export default {
  meta: {
    title: '上险量管理'
  }
};
